import { EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import { HttpClientTimeoutModule } from './timeout.module';

export const providerHttpClientTimeout = (): Array<Provider | EnvironmentProviders> => {
	return [importProvidersFrom(HttpClientTimeoutModule)];
};
